import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Invoice, PetInsuranceData } from "../../models";
import { DataStorageService } from "../../services/data-storage.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: 'cpf-invoice-detail-page',
  templateUrl: './invoice-detail-page.component.html',
  styleUrls: ['./invoice-detail-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InvoiceDetailPageComponent implements OnDestroy {
  public invoice?: Invoice;
  public petData?: PetInsuranceData;
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private dataStorageService: DataStorageService,
    private router: Router
  ) {
    this.route.params.pipe(
      takeUntil(this.destroy$)
    ).subscribe(params => {
      const invoiceId = params['id'];
      if (!invoiceId) {
        return;
      }

      const petWithInvoice = this.findPetByInvoiceId(invoiceId);
      if (!petWithInvoice) {
        this.router.navigate(['calingo', 'pet', 'invoice']);
        return;
      }

      this.updateComponentState(petWithInvoice, invoiceId);
    });

    this.dataStorageService.selectedData$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(pet => {
      if (this.petData && pet && this.petData.full_contract_number === pet.full_contract_number) {
        return
      }

      this.router.navigate(['calingo', 'pet', 'invoice']);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private findPetByInvoiceId(invoiceId: string): PetInsuranceData | undefined {
    return this.dataStorageService.getAllData
      .find(pet => pet.invoices?.some(invoice => invoice.invoiceNumber === invoiceId));
  }

  private updateComponentState(pet: PetInsuranceData, invoiceId: string): void {
    this.invoice = pet.invoices?.find(invoice => invoice.invoiceNumber === invoiceId);
    this.petData = pet;
    this.dataStorageService.selectedData = pet;
  }
}
